<div class="custom-ng-select-container">
    <ng-select 
      [isOpen]="isOpen"
      [items]="items"
      [multiple]="multiselect"
      [loading]="loading"
      [bindLabel]="bindLabel"
      [(ngModel)]="selectedItems"
      [searchable]="true"
      [ngModelOptions]="{standalone: true}"
      [clearSearchOnAdd]="true"
      (close)="rearrangeItems()"
      (change)="emitSelection()"
      dropdownPosition="bottom"
      notFoundText="{{'Nothinghere' | localize}}"
      [placeholder]="placeholder"
      [closeOnSelect]="closeOnSelect">

    
    <!-- Label template -->
    <ng-template ng-label-tmp let-item="item" *ngIf="!multiselect">
        <span class="d-flex align-items-center">
        <img height="17" width="17" class="mr-1 border border-light rounded p-1"
         [src]="item.oragnizationDescriptions?.flag ? item.oragnizationDescriptions.flag:'assets/common/images/organisationUnit/Default%20Organization%20Unit%20(1)%20(1).svg'">
            {{item.displayName | slice:0:1}}{{item.displayName.length > 1 ? '..' : ''}}
        </span>
    </ng-template>


    <!-- Multi label -->
    <ng-template ng-multi-label-tmp let-items="items" *ngIf="multiselect" let-clear="clear">
        <div class="ng-value" *ngFor="let item of items | slice:0:1; trackBy: trackByIndex">
            <span class="ng-value-label d-flex align-items-center">
            <img height="17" width="17" class="mr-1 border border-light rounded p-1" [src]="item.oragnizationDescriptions?.flag ? item.oragnizationDescriptions.flag:'assets/common/images/organisationUnit/Default%20Organization%20Unit%20(1)%20(1).svg'">
                {{item.displayName | slice:0:5}}{{item.displayName.length > 5 ? '..' : ''}}
                <span class="ng-value-icon right ml-3" (click)="clear(item)" aria-hidden="true">×</span>
            </span>
        </div>
        <div class="ng-value" *ngIf="items.length > 1">
            <span class="ng-value-label">{{items.length - 1}} {{'More' | localize}}...</span>
        </div>
    </ng-template>

         
    <!-- Multiselet Option template -->
    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index" *ngIf="multiselect">
        <div class="d-flex">
            <label class="checkbox mr-0">
                <input id="item-{{index}}" name="item-{{index}}"  type="checkbox" [ngModel]="item$.selected"
                        />
                <span (click)="checkUncheck(item$)"></span>
            </label>
            <div class="d-flex justify-content-center align-items-center rounded mx-1" style="width: 40px; height: 40px;">
                <img style="width: 40px; height: 40px;" 
                [src]="item.oragnizationDescriptions?.flag ? item.oragnizationDescriptions?.flag : 'assets/common/images/organisationUnit/Default%20Organization%20Unit%20(1)%20(1).svg'" 
                class="w-40px h-40px img-fluid border border-light rounded p-1" id="profimgsize">
            </div>

            <div class="d-flex align-items-start justify-content-center flex-column ml-2 text-dark-75"  pTooltip="{{ item.displayName }}" [tooltipDisabled]="item.displayName | tooltipDisabled:15" tooltipPosition="bottom">
                <div class="font-weight-bold team-label-name">{{item.displayName | slice:0:15}}{{item.displayName?.length > 15 ? '...' : ''}}</div>
                </div>
        </div>
    </ng-template>

    <!-- Option template -->
    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index" *ngIf="!multiselect">
        <div class="d-flex">
            <div class="d-flex justify-content-center align-items-center rounded mx-1" style="width: 40px; height: 40px;">
                <img style="width: 40px; height: 40px;" src="{{ item.profileImage }}" class="w-40px h-40px img-fluid border-light rounded p-1" id="profimgsize">
            </div>
            <div class="d-flex align-items-start justify-content-center flex-column ml-2 text-dark-75">
                <div class="font-weight-bold">{{ item.displayName }}</div>
            </div>
        </div>
    </ng-template>

  
    <!-- Header template -->
    <ng-template ng-header-tmp *ngIf="multiselect && items && items.length">
        <div class="d-flex cursor-pointer" (click)="showselectall ? selectAll() : unselectAll()">
            <label *ngIf="showselectall" class="checkbox ml-1 mr-2">
                <input id="item" name="item"  type="checkbox" [ngModel]="!showselectall" (ngModelChange)="showselectall = $event"
                    />
                <span></span>
            </label>
            <label *ngIf="showdeselectall" class="checkbox ml-1 mr-2">
                <input id="item" name="item"  type="checkbox" [ngModel]="!showselectall" (ngModelChange)="showselectall = $event"
                    />
                <span></span>
            </label>
            <span *ngIf="showselectall" class="pointer my-2" >{{'Selectall' | localize}}</span>
            <span *ngIf="showdeselectall" class="pointer my-2">{{'Selectall' | localize}}</span>
        </div>
    </ng-template>
  
    <!-- Footer template -->
    <ng-template *ngIf="multiselect && items && items.length" ng-footer-tmp>
        <div class="text-muted" style="font-size: 0.8rem;">{{ selectedItems ? selectedItems.length : '0' }} {{ selectedItems && (selectedItems.length === 0 || selectedItems.length > 1) ? ('items' | localize) : 'Item' | localize}} {{'selected' | localize}}</div>
    </ng-template>

    <!-- Loader template -->
    <ng-template ng-loadingspinner-tmp>
        <div class="spinner spinner-primary mr-7"></div>
    </ng-template>

    <!-- Type to search -->
    <ng-template ng-typetosearch-tmp>
        <div class="ng-option disabled">
            {{'Starttyping' | localize}}
        </div>
    </ng-template>

    <!-- Not found -->
    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
        <div class="ng-option disabled">
            {{'Nodatafoundfor' | localize}} "{{searchTerm}}"
        </div>
    </ng-template>

    <!-- Loading template -->
    <ng-template ng-loadingtext-tmp let-searchTerm="searchTerm">
        <div class="ng-option disabled d-flex justify-content-center align-items-center">
            <div class="spinner spinner-primary my-4"></div>
        </div>
    </ng-template>
  </ng-select>
  </div>
